import { 
  useCreateDirectoryMutation, 
  useDeleteDirectoryMutation, 
  useMoveFileMutation, 
  useDeleteFileMutation 
} from '../mediaApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useMediaActions = () => {
  const [createDirectoryTrigger] = useCreateDirectoryMutation();
  const [deleteDirectoryTrigger] = useDeleteDirectoryMutation();
  const [moveFileTrigger] = useMoveFileMutation();
  const [deleteFileTrigger] = useDeleteFileMutation();

  const createDirectory = async ({ directoryId, name }) => {
    try {
      const result = await createDirectoryTrigger({ directoryId, name }).unwrap();
      enqueueSnackbar(i18next.t('media.folderCreated'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('media.folderCreatedFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  const deleteDirectory = async (id) => {
    try {
      const result = await deleteDirectoryTrigger(id).unwrap();
      enqueueSnackbar(i18next.t('media.folderDeleted'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('media.folderDeletedFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  const moveFile = async ({ id, directoryId }) => {
    try {
      const result = await moveFileTrigger({ id, directoryId }).unwrap();
      enqueueSnackbar(i18next.t('media.folderChanged'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('media.fileMovedFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  const deleteFile = async ({ id }) => {
    try {
      const result = await deleteFileTrigger({ id }).unwrap();
      enqueueSnackbar(i18next.t('media.fileDeleted'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('media.fileDeletedFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    createDirectory,
    deleteDirectory,
    moveFile,
    deleteFile,
  };
};
